import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ourfaq",
  class: "bglight position-relative padding"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 text-center wow fadeIn\" data-wow-delay=\"300ms\"><h2 class=\"heading bottom40 darkcolor font-light2\"><span class=\"font-normal\">Validasi Dokumen Surat Keterangan</span><span class=\"divider-center\"></span></h2><div class=\"col-md-8 offset-md-2 heading_space\"><p></p></div></div>", 1)
const _hoisted_5 = { class: "col-lg-12 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow" }
const _hoisted_6 = {
  key: 0,
  class: "widget logincontainer"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/success.png",
  style: {"width":"80px"},
  class: "text-center",
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-success" }, "Dokumen Valid", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/error.png",
  style: {"width":"80px"},
  class: "text-center",
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "text-danger" }, "Url Tidak Valid", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 2,
  class: "table"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"40%"} }, " Nama (badan usaha/ nonbadan usaha/ perseorangan ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Alamat", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "No. Tlp/Fax/HP", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "NIB untuk badan usaha / NIK", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "NPWP", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, " Lokasi Instalasi Penyedia Tenaga Listrik ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Kapasitas", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Penggunaan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_overlay, {
            show: _ctx.loadingCard,
            rounded: "sm"
          }, {
            default: _withCtx(() => [
              (!_ctx.loadingCard)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_ctx.resultData != null)
                      ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _hoisted_8,
                            _hoisted_9,
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.resultData == null)
                      ? (_openBlock(), _createBlock(_component_center, { key: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _hoisted_12,
                            _hoisted_13,
                            _hoisted_14
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_15,
                    _hoisted_16,
                    (_ctx.resultData)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                          _createElementVNode("tr", null, [
                            _hoisted_18,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.nama_badan_usaha), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_19,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.alamat), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_20,
                            _createElementVNode("th", null, " : " + _toDisplayString(_ctx.resultData.no_telp != "" ? _ctx.resultData.no_telp : "-") + " / " + _toDisplayString(_ctx.resultData.no_fax != "" ? _ctx.resultData.no_fax : "-") + " / " + _toDisplayString(_ctx.resultData.no_hp != "" ? _ctx.resultData.no_hp : "-"), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_21,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.no_identitas), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_22,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.npwp), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_23,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.lokasi_alamat), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_24,
                            (_ctx.resultData.teknis_jenis_pembangkit == 'PLTD')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_25, [
                                  _createTextVNode(" : "),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultData.kategori_pembangkit, (item) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                                      (item.jenis == 'Generator')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(item.kapasitas) + " KW ", 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.resultData.teknis_jenis_pembangkit == 'PLTS')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_26, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultData.kategori_pembangkit, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.getKapasitas(item, index)
                                      }, null, 8, _hoisted_27)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_28,
                            _createElementVNode("th", null, ": " + _toDisplayString(_ctx.resultData.jenis_penggunaan), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ])
    ])
  ]))
}